import React, { memo } from "react";

import type { LoadingProps } from "./loading.types";

import Backdrop from "@/components/shared/Backdrop";

import s from "./loading.module.scss";

const Loading = ({ visible = false }: LoadingProps) => (
  <div className={s.wrapper} data-is-visible={visible}>
    <Backdrop open={visible} />
    {visible && (
      <img
        src="/inst/img/icon/spinner.svg"
        width={64}
        height={64}
        alt="Carregando"
      />
    )}
  </div>
);

export default memo(Loading);
